export default __webpack_public_path__ + "static/media/maure_de_bretagne7.e0bae508.jpg";